module.exports = __webpack_public_path__ + "static/media/_rituals_qr_onboarding_header_beam_extra_small.b933e30e.png";